<template>
  <div>
    <a class="donation_content_btn" v-if="checkDownload" :href="fileData.org_url" target="_blank" download>후원하기</a>
  </div>
</template>

<script>
import util from "@/mixins/util";

export default {

  name: "FileComponent",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      fileData: {}
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.getFile()
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getFile() {
      let params = {
        a_container_type: 'supportDownload',
        a_container_id: 1
      }
      this.$api.$file.getFile(params).then(res => res.Data.Result).then(res => {
        if (res.Info.type === 1) {
          this.fileData = res.List[0];
        } else {
          this.errorAlert('파일을 불러올 수 없습니다.');
        }
      })
    },
    checkDownload() {
      return !util.isEmpty(this.fileData.org_url);
    },
  },
  watch: {},
}
</script>

<style scoped>
.donation_content_btn {
  margin-right: 15px;
  float: right;
  margin-bottom: 19px;
  width: 98px;
  height: 32px;
  background-color: #009bbe;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff !important;
  line-height: 32px;
  border-radius: 6px;
}
</style>